import { ROUTER_BASE_PATH } from "@/const"
import * as Sentry from "@sentry/react"
import { logoutUser } from "@myeway/auth"
import { Button, Stack } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import type { AppDispatch } from "@/store"
import { useEffect } from "react"

const ErrorPage = ({ error }: { error: Error }) => {
	const dispatch = useDispatch<AppDispatch>()
	const { t } = useTranslation()

	// Report problem to Sentry
	useEffect(() => {
		if (error) {
			Sentry.captureException(error)
		}
	}, [])

	return (
		<Stack gap={3} className="p-3">
			<div>{t("Tapahtui odottamaton virhe. Virheestä on ilmoitettu sivuston ylläpitäjille.")}</div>
			<div>
				<div>{t("Virheviesti")}:</div>
				<pre style={{ color: "red" }}>{typeof error === "string" ? error : error.message}</pre>
			</div>
			<div>
				<Button
					onClick={() => {
						window.location.replace(ROUTER_BASE_PATH + "/")
					}}
				>
					{t("Palaa kotisivulle")}
				</Button>
			</div>
			<div>
				<Button
					onClick={() => {
						dispatch(logoutUser({}))
						window.location.replace(ROUTER_BASE_PATH + "/login")
					}}
				>
					{t("Kirjaudu ulos")}
				</Button>
			</div>
		</Stack>
	)
}

export default ErrorPage
